const ACTIVE_STATUS = "active-string";

export const COACH_DASHBOARD_DELETE_FLOW = Object.freeze({
  ACTIVE_TYPED_NAME: "active_typed_name",
  INVITATION_ONE_CLICK: "invitation_one_click",
  INVITATION_TYPED_EMAIL: "invitation_typed_email",
});

const normalizeString = (value) =>
  typeof value === "string" ? value.trim() : "";

const normalizeLowercase = (value) => normalizeString(value).toLowerCase();

const hasNonEmptyString = (value) => normalizeString(value) !== "";

export const isDashboardInvitationClient = (client) => {
  const status = normalizeString(client?.status);
  if (status === ACTIVE_STATUS) return false;

  return (
    client?.usePendingBlocksPath === true || hasNonEmptyString(client?.invitationId)
  );
};

export const canOpenDashboardClient = (client) => {
  const status = normalizeString(client?.status);
  if (status === ACTIVE_STATUS) return true;
  return client?.usePendingBlocksPath === true;
};

export const isLegacyNonOpenableInvitationClient = (client) =>
  isDashboardInvitationClient(client) && !canOpenDashboardClient(client);

export const getExpectedAthleteDeleteValue = (client) => {
  const name = normalizeString(client?.nameForCoach ?? client?.name);
  const surname = normalizeString(client?.surnameForCoach ?? client?.surname);
  const fullName = [name, surname].filter(Boolean).join(" ").trim();
  if (fullName) return fullName;
  return normalizeString(client?.email);
};

export const getExpectedInvitationDeleteEmail = (client) =>
  normalizeString(client?.invitationEmail ?? client?.email);

export const resolveDashboardClientActionPolicy = ({ client }) => {
  const invitationClient = isDashboardInvitationClient(client);
  const canOpen = canOpenDashboardClient(client);
  const isLegacyInvitation =
    invitationClient && isLegacyNonOpenableInvitationClient(client);

  if (!invitationClient) {
    return {
      isInvitationClient: false,
      canOpen,
      isLegacyNonOpenableInvitation: false,
      deleteFlow: COACH_DASHBOARD_DELETE_FLOW.ACTIVE_TYPED_NAME,
      deleteLabelKey: "deleteClient-string",
      deleteEntity: "athlete",
      expectedTypedValue: getExpectedAthleteDeleteValue(client),
    };
  }

  if (isLegacyInvitation) {
    return {
      isInvitationClient: true,
      canOpen,
      isLegacyNonOpenableInvitation: true,
      deleteFlow: COACH_DASHBOARD_DELETE_FLOW.INVITATION_ONE_CLICK,
      deleteLabelKey: "deleteInvitation-string",
      deleteEntity: "invitation",
      expectedTypedValue: "",
    };
  }

  const expectedTypedValue = getExpectedInvitationDeleteEmail(client);
  const shouldUseTypedDelete = hasNonEmptyString(expectedTypedValue);

  return {
    isInvitationClient: true,
    canOpen,
    isLegacyNonOpenableInvitation: false,
    deleteFlow: shouldUseTypedDelete
      ? COACH_DASHBOARD_DELETE_FLOW.INVITATION_TYPED_EMAIL
      : COACH_DASHBOARD_DELETE_FLOW.INVITATION_ONE_CLICK,
    deleteLabelKey: "deleteInvitation-string",
    deleteEntity: "invitation",
    expectedTypedValue: shouldUseTypedDelete ? expectedTypedValue : "",
  };
};

export const matchesDeleteConfirmationInput = ({ input, expectedValue }) => {
  const normalizedExpectedValue = normalizeLowercase(expectedValue);
  if (!normalizedExpectedValue) return false;
  return normalizeLowercase(input) === normalizedExpectedValue;
};
